import { makeApiRequest, generateSymbol } from "./helpers.js";
import { subscribeOnStream, unsubscribeFromStream } from "./streaming.js";

const url = new URL(window.location.href)
const tmpData = url.pathname.split("/")

const configurationData = {
  supports_search: false,
  supports_group_request: false,
  supports_marks: false,
  supports_timescale_marks: false,
  supports_time: true,
  // Represents the resolutions for bars supported by your datafeed
  supported_resolutions: ['1', '30', '60', '1D', '3D', '1W', '1M'],
  // The `exchanges` arguments are used for the `searchSymbols` method if a user selects the exchange
  exchanges: [
    { value: 'GudangKripto', name: 'GudangKripto', desc: 'GudangKripto Exchange' },
  ],
  // The `symbols_types` arguments are used for the `searchSymbols` method if a user selects this symbol type
  symbols_types: [
    { name: 'crypto', value: 'crypto' }
  ]
};

const lastBarsCache = new Map();

async function getAllSymbols() {

  const apiPath = (tmpData.length >= 4 ? (tmpData[3].toUpperCase() !== '' ? `api/socket/exchange-info?symbol=${tmpData[3].toUpperCase()}_${tmpData[4].toUpperCase()}&interval=30` : `api/socket/exchange-info?symbol=ADA_IDR&interval=30`) : `api/socket/exchange-info?symbol=ADA_IDR&interval=30`);
  const data = await makeApiRequest(apiPath);

  let allSymbols = [];
  for (const exchange of configurationData.exchanges) {
    const symbol = generateSymbol(exchange.value, data.symbols[0].baseAsset, data.symbols[0].quoteAsset)
    // console.log("DATA SYMBOL :"+data)
    allSymbols = [{
      symbol: symbol.symbol,
      full_name: symbol.full,
      description: symbol.short,
      exchange: exchange.value,
      type: 'crypto',
    }]
  }
  return allSymbols
}

// async function resetChart() {

// }

const Datafeed = {
  onReady: (callback) => {
    // console.log('[onReady]: Method call');
    setTimeout(() => callback(configurationData));
  },
  searchSymbols: async (
    userInput,
    exchange,
    symbolType,
    onResultReadyCallback
  ) => {
    // console.log('[searchSymbols]: Method call');
    const symbols = await getAllSymbols();
    // console.log('s : '+symbols)
    const newSymbols = symbols.filter(symbol => {
      const isExchangeValid = exchange === '' || symbol.exchange === exchange;
      const isFullSymbolContainsInput = symbol.full_name.toLowerCase().indexOf(userInput.toLowerCase()) !== -1;
      return isExchangeValid && isFullSymbolContainsInput;
    });
    onResultReadyCallback(newSymbols);
  },
  resolveSymbol: async (
    symbolName,
    onSymbolResolvedCallback,
    onResolveErrorCallback,
    extension
  ) => {
    // console.log('[resolveSymbol]: Method call', symbolName);
    const symbols = await getAllSymbols();
    // console.log(symbols)
    const symbolItem = symbols.find(({ symbol }) => symbol === symbolName);
    if (!symbolItem) {
      // console.log('[resolveSymbol]: Cannot resolve symbol', symbolName);
      onResolveErrorCallback('Cannot resolve symbol');
      return;
    }
    // Symbol information object
    const symbolInfo = {
      ticker: symbolItem.symbol,
      name: symbolItem.symbol,
      description: symbolItem.description,
      type: symbolItem.type,
      session: '24x7',
      timezone: 'Asia/Jakarta',
      exchange: symbolItem.exchange,
      minmov: 1,
      pricescale: (tmpData.length >= 4 ? (tmpData[4].toLowerCase() === 'usdt' ? 10000 : (tmpData[4].toLowerCase() === 'gidr' ? 1000000000 : 100)) : 100),
      visible_plots_set: 'ohlc',
      has_intraday: true,
      intraday_multipliers: ['1', '30', '60'],
      // has_daily: true,
      has_no_volume: false,
      daily_multipliers: ['1', '3'],
      has_weekly_and_monthly: true,
      // has_empty_bars: true,
      supported_resolutions: configurationData.supported_resolutions,
      // volume_precision: 2,
      volume_precision: (tmpData.length >= 4 ? (tmpData[4].toLowerCase() === 'usdt' ? 4 : (tmpData[4].toLowerCase() === 'gidr' ? 9 : 2)) : 2),
      data_status: 'streaming',
    };

    onSymbolResolvedCallback(symbolInfo);
  },
  getBars: async (symbolInfo, resolution, periodParams, onHistoryCallback, onErrorCallback) => {
    const { firstDataRequest, from, to } = periodParams;

    try {
      let tmpInterval;
      if (resolution === '1') {
        tmpInterval = '1m'; //1
      } else if (resolution === '60') {
        tmpInterval = '1h'; //60
      } else if (resolution === '30') {
        tmpInterval = '30m'; //30
      } else if (resolution === '1D') {
        tmpInterval = '1d'; //24
      } else if (resolution === '3D') {
        tmpInterval = '3d'; //4320
      } else if (resolution === '1W') {
        tmpInterval = '7d'; //10080
      } else if (resolution === '1M') {
        tmpInterval = '30d'; //43200
      }

      const apiPath = (tmpData.length >= 4
        ? (tmpData[3].toUpperCase() !== ''
            ? `api/socket/kline/history?symbol=${tmpData[3].toUpperCase()}_${tmpData[4].toUpperCase()}&interval=${tmpInterval}&from=${from}&to=${to}`
            : `api/socket/kline/history?symbol=ADA_IDR&interval=${tmpInterval}&from=${from}&to=${to}`)
        : `api/socket/kline/history?symbol=ADA_IDR&interval=${tmpInterval}&from=${from}&to=${to}`);
      const data = await makeApiRequest(apiPath);
     
      if (!Array.isArray(data) || data.length === 0) {
        onHistoryCallback([], { noData: true });
        return;
      }

      const requestedBars = periodParams.countBack ?? data.length;
      const bars = data
        .slice(-requestedBars)
        .map(kline => ({
          time: kline[0],
          open: parseFloat(kline[1]),
          high: parseFloat(kline[2]),
          low: parseFloat(kline[3]),
          close: parseFloat(kline[4]),
          volume: parseFloat(kline[5]),
        }));

      if (firstDataRequest) {
        lastBarsCache.set(symbolInfo.full_name, { ...bars[bars.length - 1] });
      }
      
      onHistoryCallback(bars, { noData: false });
    } catch (error) {
      onHistoryCallback([], { noData: false });
    }
  },
  subscribeBars: (
    symbolInfo,
    resolution,
    onRealtimeCallback,
    subscriberUID,
    onResetCacheNeededCallback
  ) => {
    // console.log('[subscribeBars]: Method call with subscriberUID:', subscriberUID);
    subscribeOnStream(
      symbolInfo,
      resolution,
      onRealtimeCallback,
      subscriberUID,
      onResetCacheNeededCallback(console.log("TV-R-D")),
      lastBarsCache.get(symbolInfo.full_name)
    );
  },
  unsubscribeBars: (subscriberUID) => {
    // console.log('[unsubscribeBars]: Method call with subscriberUID:', subscriberUID);
    unsubscribeFromStream(subscriberUID);
  },
};

export default Datafeed;